export enum SuggestionStatus {
    Approved = 'approved',
    Pending = 'pending',
    Rejected = 'rejected',
}
